module.exports = "/images/info-pink.svg?3a28d8e36688145d4587a2177c07d65a";